import { Wishlist } from 'components'
import React from 'react'

const WishlistPage = () => {
  return (
    <div>
        <Wishlist/>
      
    </div>
  )
}

export  {WishlistPage}
